
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-defi-framework/api/legacy/get_enabled_coins",
      function () {
        return require("private-next-pages/en/docs/komodo-defi-framework/api/legacy/get_enabled_coins/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-defi-framework/api/legacy/get_enabled_coins"])
      });
    }
  